import { useTranslation } from "@refinedev/core";
import { Label } from "components/label";
import { IAdditionalSetupData, UserType } from "interfaces";
import { canAccessByType, getPaymentMethodLabel } from "utills/helpers";

export const PaymentMethod = ({
  additionalSetupData,
}: {
  additionalSetupData: IAdditionalSetupData | null;
}) => {
  const { translate } = useTranslation();
  return (
    <div className="box-container p-4 text-sm sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
        <div className="sm:col-span-3">
          <Label
            required
            id="payment_method.ignore_payment_methods"
            name={translate(
              "eventSetup.additionalSetup.paymentMethod.choosePaymentMethod"
            )}
          />
          <div className="flex items-center flex-wrap gap-x-2">
            {(additionalSetupData?.ignore_payment_methods ?? []).map(
              (method, index) => (
                <div
                  key={index}
                  className="mt-2 w-fit flex items-center px-3 py-1.5 bg-magnolia-500 ring-magnolia-500 text-brand-500 text-xs rounded-md font-medium break-all"
                >
                  <p className="align-middle">
                    {getPaymentMethodLabel(method)}
                  </p>
                </div>
              )
            )}
          </div>
        </div>
        {canAccessByType(UserType.ADMIN) ? (
          <div className="sm:col-span-3">
            <Label
              id="payment_method.payment_gateway_promotion_id"
              name="OnePay promotion id"
            />
            {additionalSetupData?.payment_gateway_promotion_id || (
              <span className="text-gray-400">N/A</span>
            )}
          </div>
        ) : <></>}

        {canAccessByType(UserType.ADMIN) &&
          <div className="sm:col-span-3">
            <Label
              id="payment_method.order_code_prefix"
              name={translate(
                "eventSetup.additionalSetup.paymentMethod.orderCodePrefix"
              )}
            />
            {additionalSetupData?.order_code_prefix}
          </div>
        }
      </div>
    </div>
  );
};
